var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 pl-5"
  }, [_c('div', {
    staticClass: "vertical-line"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "dot"
  })]), _c('div', {
    staticClass: "pl-3 content-log text-black"
  }, [_c('strong', [_vm._v("Mochammad Zuhrianto")]), _c('div', {
    staticClass: "d-flex align-items-center mb-1 text-blue-400"
  }, [_c('i', {
    staticClass: "fa fa-calendar mr-2"
  }), _c('p', {
    staticClass: "text-sm mb-0"
  }, [_vm._v("11 Feb 2024 14:00")])]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v("Service Repair Has Been Approved")]), _c('p', {
    staticClass: "text-sm mb-0"
  }, [_vm._v("Comment:")]), _c('small', [_vm._v("Data sudah saya approve dan lanjutkan untuk proses repair")])])])]);

}]

export { render, staticRenderFns }